import { Link } from "react-router-dom";
import { useState } from "react";
import PageBanner from "@/components/feature/PageBanner";
import Reveal from "@/components/feature/Reveal";
import { notices } from "@/mocks/notices";

const categories = ["전체", "공지", "신제품", "전시회", "채용"];

export default function Notice() {
  const [activeCategory, setActiveCategory] = useState("전체");

  const filtered =
    activeCategory === "전체" ? notices : notices.filter((notice) => notice.category === activeCategory);
  const pinnedNotices = activeCategory === "전체" ? notices.filter((notice) => notice.pinned) : [];
  const listNotices = activeCategory === "전체" ? notices.filter((notice) => !notice.pinned) : filtered;

  return (
    <>
      <PageBanner
        eyebrow="NOTICE"
        title="NOTICE"
        description="동우스톤의 전시 일정, 신제품 소식, 운영 안내를 확인하세요."
        image="https://readdy.ai/api/search-image?query=minimal%20bright%20office%20interior%20with%20warm%20wood%20desk%20and%20stone%20samples%2C%20soft%20natural%20daylight%2C%20neutral%20beige%20palette%2C%20clean%20calm%20architectural%20photography&width=1800&height=900&seq=stone-banner-notice&orientation=landscape"
        imageAlt="동우스톤 사무 공간"
        current="NOTICE"
      />

      <section className="bg-background-50">
        <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
          <div className="flex flex-wrap gap-2">
            {categories.map((category) => {
              const isActive = activeCategory === category;
              return (
                <button
                  key={category}
                  type="button"
                  onClick={() => setActiveCategory(category)}
                  className={`cursor-pointer whitespace-nowrap rounded-full border px-4 py-2 text-sm transition-colors ${
                    isActive
                      ? "border-primary-500 bg-primary-500 text-background-50"
                      : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
                  }`}
                >
                  {category}
                </button>
              );
            })}
          </div>

          {pinnedNotices.length > 0 && (
            <div className="mt-8 space-y-3">
              {pinnedNotices.map((notice, index) => (
                <Reveal key={notice.id} delay={index * 70}>
                  <Link
                    to={`/notice/${notice.id}`}
                    className="flex flex-col gap-3 rounded-lg border border-primary-200 bg-primary-50/60 p-5 transition-colors hover:border-primary-400 md:flex-row md:items-center md:gap-6 md:p-6"
                  >
                    <span className="inline-flex w-fit items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 font-label text-[11px] font-medium text-background-50">
                      <i className="ri-pushpin-2-fill text-xs" /> 중요
                    </span>
                    <div className="flex-1">
                      <h3 className="font-heading text-lg text-foreground-950">{notice.title}</h3>
                      <p className="mt-1 line-clamp-1 text-sm text-foreground-600">
                        {notice.content.split("\n")[0]}
                      </p>
                    </div>
                    <span className="shrink-0 text-xs text-foreground-500">{notice.date}</span>
                  </Link>
                </Reveal>
              ))}
            </div>
          )}

          <div className="mt-6 overflow-hidden rounded-lg border border-background-200">
            {listNotices.length > 0 ? (
              listNotices.map((notice) => (
                <Link
                  key={notice.id}
                  to={`/notice/${notice.id}`}
                  className="group flex flex-col gap-2 border-b border-background-200 bg-background-50 px-5 py-5 transition-colors last:border-b-0 hover:bg-background-100 md:flex-row md:items-center md:gap-6 md:px-6"
                >
                  <span className="inline-flex w-fit rounded-full bg-secondary-100 px-3 py-1 font-label text-[11px] font-medium text-secondary-800">
                    {notice.category}
                  </span>
                  <h3 className="flex-1 text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
                    {notice.title}
                  </h3>
                  <div className="flex shrink-0 items-center gap-4 text-xs text-foreground-500">
                    <span>{notice.author}</span>
                    <span>{notice.date}</span>
                  </div>
                </Link>
              ))
            ) : (
              <div className="flex flex-col items-center bg-background-50 py-20 text-center">
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-foreground-500">
                  <i className="ri-file-list-3-line text-2xl" />
                </span>
                <h3 className="mt-5 font-heading text-xl text-foreground-950">등록된 공지가 없습니다</h3>
                <p className="mt-2 text-sm text-foreground-600">다른 카테고리를 선택해 확인해 보세요.</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}